import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchConversation(params) {
  try {
    const conversation = yield call(function() {
      return Api.get(`/conversation/${params.id}`)
    });
    yield put({type: 'FETCH.CONVERSATION.SUCCESS', conversation});
  } catch (error) {
    yield put({type: 'FETCH.CONVERSATION.FAILURE', error});
  }
}

function* sendMessage(params) {
  try {
    const conversation = yield call(function() {
      return Api.post(`/conversation/vin/${params.vin}/message`, params.body)
    });
    yield put({type: 'SAVE.CONVERSATION_MESSAGE.SUCCESS', conversation});
    yield put({type: 'FETCH.INTERVENTION_STATUS.REQUEST', id:conversation.body.interventionId});
  } catch (error) {
    yield put({type: 'SAVE.CONVERSATION_MESSAGE.FAILURE', error});
  }
}

function* markAsRead(params) {
  try {
    const conversation = yield call(function() {
      return Api.post(`/conversation/vin/${params.vin}/read`, {})
    });
    yield put({type: 'SAVE.CONVERSATION_MARK_AS_READ.SUCCESS', conversation});
    yield put({type: 'FETCH.INTERVENTION_STATUS.REQUEST', id:conversation.body.interventionId});
  } catch (error) {
    yield put({type: 'SAVE.CONVERSATION_MARK_AS_READ.FAILURE', error});
  }
}

export function* watchConversation() {
  yield takeEvery('FETCH.CONVERSATION.REQUEST', fetchConversation)
  yield takeEvery('SAVE.CONVERSATION_MESSAGE.REQUEST', sendMessage)
  yield takeEvery('SAVE.NEW_MESSAGE_RECEIVED.REQUEST', receiveNewMessage)
  yield takeEvery('SAVE.MESSAGE_READ.REQUEST', receiveReadMessage)
  yield takeEvery('SAVE.CONVERSATION_MARK_AS_READ.REQUEST', markAsRead)
}


function* receiveNewMessage(message) {
    yield put({type: 'SAVE.NEW_MESSAGE_RECEIVED.SUCCESS', message});
}


function* receiveReadMessage(readAcknowledge) {
  yield put({type: 'SAVE.MESSAGE_READ.SUCCESS', readAcknowledge});
}


